import React, { useEffect, useState } from 'react';

export default function Settings() {
  
  const [watchlist, setWatchlist] = useState([]);
  const [newTicker, setNewTicker] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetch('/api/rule-set', { credentials: 'include' })
      .then(r => r.json())
      .then(data => { setWatchlist(data.watchlist || []); });
  }, []);

  const save = (newList) => {
    setSaving(true);
    setMessage(null);
    fetch('/api/rule-set/watchlist', {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ watchlist: newList }),
    })
      .then(r => r.json())
      .then(() => { setMessage('Saved.'); setSaving(false); })
      .catch(() => { setMessage('Save failed.'); setSaving(false); });
  };

  const add = () => {
    const t = newTicker.trim().toUpperCase();
    if (!t || watchlist.includes(t)) return;
    const updated = [...watchlist, t];
    setWatchlist(updated);
    setNewTicker('');
    save(updated);
  };

  const remove = (ticker) => {
    const updated = watchlist.filter(t => t !== ticker);
    setWatchlist(updated);
    save(updated);
  };

  return (
    <>
      <div className="topbar">
        <span className="page-title">Settings</span>
      </div>

      <div style={{ maxWidth: 480 }}>
        <div style={{ fontSize: 13, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 16 }}>Watchlist</div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 20 }}>
          {watchlist.map(ticker => (
            <div key={ticker} style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#1e2533', border: '0.5px solid #2d3748', borderRadius: 6, padding: '6px 12px' }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: '#f1f5f9' }}>{ticker}</span>
              <button onClick={() => remove(ticker)} style={{ background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: 14, lineHeight: 1, padding: 0 }}>×</button>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <input
            value={newTicker}
            onChange={e => setNewTicker(e.target.value.toUpperCase())}
            onKeyDown={e => e.key === 'Enter' && add()}
            placeholder="Add ticker (e.g. HOOD)"
            style={{ flex: 1, background: '#141920', border: '0.5px solid #2d3748', borderRadius: 6, padding: '10px 14px', color: '#f1f5f9', fontSize: 14, outline: 'none' }}
          />
          <button onClick={add} disabled={saving} style={{ background: '#2563eb', color: '#f1f5f9', border: 'none', borderRadius: 6, padding: '10px 20px', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
            Add
          </button>
        </div>
        {message && <div style={{ fontSize: 13, color: '#4ade80', marginTop: 10 }}>{message}</div>}
      </div>
    </>
  );
}
